import React, { useMemo } from 'react';
import { Box, Flex, Button, useDisclosure, Collapse, Divider } from '@chakra-ui/react';
import { useCheckoutDispatch, useCheckoutState } from '@olo-web/client-state';
import { CardDetailsDisplay } from '../CardDetailsDisplay';
import { usePaymentDetails } from '@olo-web/domain/customer';
import { CollapseChevron } from '@olo-web/components/atoms/CollapseChevron';

const commonStyle = {
  as: Button,
  h: 'auto',
  variant: 'ghost',
  w: '100%',
  justify: 'space-between',
  align: 'center',
  p: 4,
};

export const CardAccordion = () => {
  const { data } = usePaymentDetails();
  const { selectedCard } = useCheckoutState();
  const checkoutDispatch = useCheckoutDispatch();

  const { isOpen, onToggle, onClose } = useDisclosure();

  const cardsInPanel = useMemo(() => {
    const c = data?.savedValidCards?.filter((s) => s.id !== selectedCard?.id);
    if (selectedCard) c.push(null);
    return c;
  }, [selectedCard, data]);

  const handleSelectCard = (card: IPaymentCardDetails | null) => {
    checkoutDispatch({
      type: 'SET_SELECTED_CARD',
      payload: card,
    });
    onClose();
  };

  return (
    <Box border="1px solid" borderColor="base.200" borderRadius="4px">
      <Flex
        {...commonStyle}
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls="card-details-accordion-panel"
      >
        <CardDetailsDisplay card={selectedCard} />
        <CollapseChevron isUp={isOpen} />
      </Flex>
      <Collapse in={isOpen} id="card-details-accordion-panel">
        {cardsInPanel.map((c, i) => (
          <Box key={`card-details-${c?.id || i}`}>
            <Divider borderColor="gray.200" />
            <Flex {...commonStyle} onClick={() => handleSelectCard(c)}>
              <CardDetailsDisplay card={c} />
            </Flex>
          </Box>
        ))}
      </Collapse>
    </Box>
  );
};
